import {HttpService, isAxiosError} from "./http";

class HealthGoalsService extends HttpService {
    public constructor() {
        super("/client-app/client/health-goals");
    }

    public index(filters: string | object | null = ''): Promise<any> {
        return this.http
            .get(`${this.route}/`, {
                params: filters
            })
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public show(goalId: number) {
        return this.http
            .get(`${this.route}/${goalId}`)
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public create(formData = {}) {
        return new Promise((resolve, reject) => {
            return this.http
                .post(`${this.route} `, formData)
                .then((response) => {
                    this.handleResponse.bind(this)
                    resolve(response)
                })
                .catch((error) => {
                    if (isAxiosError(error) && error.response?.status !== 422) {
                        this.handleError.bind(this);
                    }
                    reject(error);
                });
        });
    }

    public update(goalId: number, formData = {}) {
        return this.http.put(`${this.route}/${goalId}`, formData)
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }
}

export const healthGoalsService: HealthGoalsService = new HealthGoalsService();
